import React, { useState } from "react"
import { connect } from "react-redux"
import SupplierToggle from "../SupplierToggle/SupplierToggle"
import SearchLocation from "./SearchLocation"
import SupplierSearchFilterList from "./SupplierSearchFilterList"
import * as styles from "./SupplierSearchFilters.module.scss"
import useMediaQuery from "@lib/useMediaQuery"
import useWindowSize from "@lib/useWindowSize"
import * as actions from "@store/actions"
import Button from "@components/objects/Button/Button"
import closeWhite from "@images/icons/closeWhite.svg"
import filterIcon from "@images/icons/filterIcon.svg"
import searchDark from "@images/icons/searchDark.svg"
import serviceSelectIcon from "@images/icons/serviceSelectIcon.svg"
import subserviceSelectIcon from "@images/icons/starOutline.svg"

const SupplierSearchFilters = ({ staticData, updateResults, filters }) => {
  //Resize control

  const [filtersOpen, updateFiltersOpen] = useState(false)
  const { height } = useWindowSize()
  const isMobile = useMediaQuery(767)
  //consts
  const { categoryOptions, serviceCategoryOptions, subServiceOptions } = staticData

  const virtualCategory = categoryOptions?.find((el) => el.virtual)

  //handle functions
  const toggleFilterModal = () => {
    updateFiltersOpen(!filtersOpen)
  }

  const handleFilterChange = async (type, newFilter) => {
    let newFilters = { ...filters }
    newFilters[type] = newFilter
    if (!newFilter) {
      delete newFilters[type]
    }
    //remove subservices when changing service
    if (type === "services" && newFilters.subservices) {
      delete newFilters.subservices
    }

    updateResults(newFilters)
  }

  const searchbox = (
    <div className={`${styles.searchInput} ${filters.name && filters.name.length ? styles.active : ""}`}>
      <img src={searchDark} alt="search" />
      <input
        type="search"
        name="name"
        placeholder="Supplier name"
        onChange={(e) => handleFilterChange("name", e.target.value)}
        autoComplete="off"
        value={filters.name ? filters.name : ""}
      />

      <div className={styles.searchClear} onClick={() => handleFilterChange("name", null)}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg">
          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
        </svg>
      </div>
    </div>
  )

  const locationSearch = <SearchLocation updateResults={updateResults} filters={filters} />
  // const locationSearch = null

  const toggles = (
    <div className={styles.otherOptions}>
      {virtualCategory && (
        <SupplierToggle
          label="Virtual Suppliers"
          name="virtualPartyToggle"
          checked={filters && filters.category == virtualCategory.value}
          loadChecked={() => updateResults({ category: virtualCategory.value })}
          loadUnchecked={() => handleFilterChange("category", null)}
        />
      )}
      <SupplierToggle
        label="Bundles"
        name="bundlePartyToggle"
        checked={!!filters?.bundle}
        loadChecked={() => updateResults({ bundle: true })}
        loadUnchecked={() => updateResults({ bundle: false })}
      />
    </div>
  )

  const subserviceFilter =
    filters.services && filters.services.length ? (
      <SupplierSearchFilterList
        name="subservices"
        title="Speciality"
        placeholder="Select speciality"
        placeholderIcon={subserviceSelectIcon}
        className={styles.subserviceFilter}
        isMulti
        handleFilterChange={handleFilterChange}
        filter={filters.subservices}
        options={subServiceOptions
          .filter((subservice) => filters.services.some((filter) => filter === subservice.dataService.id))
          .map((subservice) => {
            subservice.active = false
            if (
              filters.subservices &&
              filters.subservices.length &&
              filters.subservices.some((filter) => filter === subservice.value)
            ) {
              subservice.active = true
            }
            return subservice
          })}
      />
    ) : null

  return (
    <form className={styles.SupplierSearchFilters}>
      {!isMobile && searchbox}
      {!isMobile && locationSearch}

      <SupplierSearchFilterList
        name="services"
        title="Services"
        placeholder="Select service"
        placeholderIcon={serviceSelectIcon}
        handleFilterChange={handleFilterChange}
        filter={filters.services}
        options={serviceCategoryOptions}
        className={styles.serviceFilter}
      />

      {isMobile && (
        <Button className={styles.openFilterBtn} design="image" image={filterIcon} onClick={toggleFilterModal} />
      )}
      {!isMobile && subserviceFilter}

      {!isMobile && toggles}

      {isMobile && locationSearch}

      {isMobile && (
        <div className={`${styles.filterMenu} ${filtersOpen ? styles.active : ""}`} style={{ height: height - 129 }}>
          <div className={styles.filterMenuTop}>
            {searchbox}
            <Button className={styles.closeFilterBtn} design="image" image={closeWhite} onClick={toggleFilterModal} />
          </div>
          {subserviceFilter}
          {toggles}
          <div className={styles.mainBtns}>
            <Button
              text="Clear All"
              design="outline"
              color="grey"
              onClick={() => {
                updateResults({})
                toggleFilterModal()
              }}
            />
            <Button text="Apply Filters" color="pink" onClick={toggleFilterModal} />
          </div>
        </div>
      )}
    </form>
  )
}

const mapStateToProps = (state) => {
  return {
    staticData: state.staticData.data,
    search: state.search.parameters,
    isSearchParamsUpdated: state.search.isUpdated,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paramLoad: (parameters) => dispatch(actions.paramLoad(parameters)),
    paramHasLoaded: () => dispatch(actions.paramHasLoaded()),
    partyUpdate: (party) => dispatch(actions.partyUpdate(party)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSearchFilters)
